import { t } from "@/i18n-js/instance";
import { ExecutePreviewCard } from "./ExecutePreviewCard";

export interface SpaceExecutePreviewProps {
  access?: string;
  name?: string;
  space_group?: string;
  type?: string;
}

export const SpaceExecutePreview = ({
  name,
  space_group,
  type,
  access,
}: SpaceExecutePreviewProps) => (
  <ExecutePreviewCard
    title={t("help_widget.copilot.execute_preview.space_title")}
    attributes={[
      {
        label: t("help_widget.copilot.execute_preview.name"),
        value: name,
      },
      {
        label: t("help_widget.copilot.execute_preview.space_group"),
        value: space_group,
      },
      {
        label: t("help_widget.copilot.execute_preview.type"),
        value: type,
      },
      {
        label: t("help_widget.copilot.execute_preview.access"),
        value: access,
      },
    ]}
  />
);
